import { getGraph } from '../../lib/getGraph';

const highlights = [
  { title: "كارولينا وانطلاقة فنية جديدة",
    photo_uri: "//media.kenanaonline.com/photos/1238694/1238694806/large_1238694806.jpg?1567113034",
  },
  { title: "و للرجل أيضا أناقته",
    photo_uri: "//media.kenanaonline.com/photos/1238695/1238695399/large_1238695399.jpg",
  },
  { title: "التأييد والمدح .. الطرق المثلى لترويض النرجسى",
    photo_uri: "//media.kenanaonline.com/photos/1238695/1238695386/large_1238695386.jpg",
  },
  { title: "أثناء الخطوبة .. احذري.. خطيبك مريض عقلي",
    photo_uri: "//media.kenanaonline.com/photos/1238694/1238694004/large_1238694004.jpg",
  },
  { title: "أنا ومامى أناقة متفردة",
    photo_uri: "//media.kenanaonline.com/photos/1238694/1238694781/large_1238694781.jpg",
  },
  { title: "أمل كلونى تحافظ على شهرتها",
    photo_uri: "//media.kenanaonline.com/photos/1238663/1238663226/large_1238663226.jpg?1545833730",
  },
  { title: "عروض عيادات تراست التخصصية",
    photo_uri: "//media.kenanaonline.com/photos/1238686/1238686887/large_1238686887.jpg",
  },
  { title: "كونى قوية .. وارفضى الاستغلال العاطفى والمادى",
    photo_uri: "//media.kenanaonline.com/photos/1238695/1238695383/large_1238695383.jpg",
  },
  { title: "متى نُسامح ونقبل الاعتذار",
    photo_uri: "//media.kenanaonline.com/photos/1238694/1238694799/large_1238694799.jpg?1567112061",
  },
  { title: "الهضبة فى الساحل الشمالى",
    photo_uri: "//media.kenanaonline.com/photos/1238694/1238694803/large_1238694803.jpg",
  }
]

const GET_MENU_ATTEMPT = "GET_MENU_ATTEMPT";
const GET_MENU_SUCCESS = "GET_MENU_SUCCESS";
const GET_MENU_FAILURE = "GET_MENU_FAILURE";
const GET_HOME_SLIDER_ATTEMPT = "GET_HOME_SLIDER_ATTEMPT";
const GET_HOME_SLIDER_SUCCESS = "GET_HOME_SLIDER_SUCCESS";
const GET_HOME_SLIDER_FAILURE = "GET_HOME_SLIDER_FAILURE";
const GET_EXPERIENCES_ATTEMPT = "GET_EXPERIENCES_ATTEMPT";
const GET_EXPERIENCES_SUCCESS = "GET_EXPERIENCES_SUCCESS";
const GET_EXPERIENCES_FAILURE = "GET_EXPERIENCES_FAILURE";
const GET_AWARDS_ATTEMPT = "GET_AWARDS_ATTEMPT";
const GET_AWARDS_SUCCESS = "GET_AWARDS_SUCCESS";
const GET_AWARDS_FAILURE = "GET_AWARDS_FAILURE";
const GET_BANNERS_ATTEMPT = "GET_BANNERS_ATTEMPT";
const GET_BANNERS_SUCCESS = "GET_BANNERS_SUCCESS";
const GET_BANNERS_FAILURE = "GET_BANNERS_FAILURE";
const GET_RESORT_ATTEMPT = "GET_RESORT_ATTEMPT";
const GET_RESORT_SUCCESS = "GET_RESORT_SUCCESS";
const GET_RESORT_FAILURE = "GET_RESORT_FAILURE";
const GET_ROOM_ATTEMPT = "GET_ROOM_ATTEMPT";
const GET_ROOM_SUCCESS = "GET_ROOM_SUCCESS";
const GET_ROOM_FAILURE = "GET_ROOM_FAILURE";
const GET_OFFERS_ATTEMPT = "GET_OFFERS_ATTEMPT";
const GET_OFFERS_SUCCESS = "GET_OFFERS_SUCCESS";
const GET_OFFERS_FAILURE = "GET_OFFERS_FAILURE";
const GET_ACTIVITIES_ATTEMPT = "GET_ACTIVITIES_ATTEMPT";
const GET_ACTIVITIES_SUCCESS = "GET_ACTIVITIES_SUCCESS";
const GET_ACTIVITIES_FAILURE = "GET_ACTIVITIES_FAILURE";
const GET_PAGE_ATTEMPT = "GET_PAGE_ATTEMPT";
const GET_PAGE_SUCCESS = "GET_PAGE_SUCCESS";
const GET_PAGE_FAILURE = "GET_PAGE_FAILURE";
const GET_CHILDREN_ATTEMPT = "GET_CHILDREN_ATTEMPT";
const GET_CHILDREN_SUCCESS = "GET_CHILDREN_SUCCESS";
const GET_CHILDREN_FAILURE = "GET_CHILDREN_FAILURE";

const GET_TOPIC_POSTS_ATTEMPT = "GET_TOPIC_POSTS_ATTEMPT"
const GET_TOPIC_POSTS_SUCCESS = "GET_TOPIC_POSTS_SUCCESS"
const GET_TOPIC_POSTS_FAILURE = "GET_TOPIC_POSTS_FAILURE"

const TOGGLE_OVERLAY = "TOGGLE_OVERLAY";

const UPDATE_SCROLL = "UPDATE_SCROLL";

const TOGGLE_BOOKING_PANEL = "TOGGLE_BOOKING_PANEL"
const SET_BOOKING_RESORT = "SET_BOOKING_RESORT"
const SET_BOOKING_DESTINATION = "SET_BOOKING_DESTINATION"
const UPDATE_BOOKING = "UPDATE_BOOKING"
const GET_HIGHLIGHTS_SUCCESS = "GET_HIGHLIGHTS_SUCCESS"

export const getMenuAttempt = (payload) => ({ type: GET_MENU_ATTEMPT, payload: payload });
export const getMenuSuccess = (payload) => ({ type: GET_MENU_SUCCESS, payload: payload });
export const getMenuFailure = (payload) => ({ type: GET_MENU_FAILURE, payload: payload });
export const getHomeSliderAttempt = (payload) => ({ type: GET_HOME_SLIDER_ATTEMPT, payload: payload });
export const getHomeSliderSuccess = (payload) => ({ type: GET_HOME_SLIDER_SUCCESS, payload: payload });
export const getHomeSliderFailure = (payload) => ({ type: GET_HOME_SLIDER_FAILURE, payload: payload });
export const getExperiencesAttempt = (payload) => ({ type: GET_EXPERIENCES_ATTEMPT, payload: payload });
export const getExperiencesSuccess = (payload) => ({ type: GET_EXPERIENCES_SUCCESS, payload: payload });
export const getExperiencesFailure = (payload) => ({ type: GET_EXPERIENCES_FAILURE, payload: payload });
export const getAwardsAttempt = (payload) => ({ type: GET_AWARDS_ATTEMPT, payload: payload });
export const getAwardsSuccess = (payload) => ({ type: GET_AWARDS_SUCCESS, payload: payload });
export const getAwardsFailure = (payload) => ({ type: GET_AWARDS_FAILURE, payload: payload });
export const getTopicPostsAttempt = (payload) => ({ type: GET_TOPIC_POSTS_ATTEMPT, payload: payload });
export const getTopicPostsSuccess = (payload) => ({ type: GET_TOPIC_POSTS_SUCCESS, payload: payload });
export const getTopicPostsFailure = (payload) => ({ type: GET_TOPIC_POSTS_FAILURE, payload: payload });

export const getOffersAttempt = (payload) => ({ type: GET_OFFERS_ATTEMPT, payload: payload });
export const getOffersSuccess = (payload) => ({ type: GET_OFFERS_SUCCESS, payload: payload });
export const getOffersFailure = (payload) => ({ type: GET_OFFERS_FAILURE, payload: payload });

export const getHighlightsSuccess = (payload) => ({ type: GET_HIGHLIGHTS_SUCCESS, payload: payload });

export const getChildrenAttempt = (payload) => ({ type: GET_CHILDREN_ATTEMPT, payload: payload });
export const getChildrenSuccess = (payload) => ({ type: GET_CHILDREN_SUCCESS, payload: payload });
export const getChildrenFailure = (payload) => ({ type: GET_CHILDREN_FAILURE, payload: payload });

export const getActivitiesAttempt = (payload) => ({ type: GET_ACTIVITIES_ATTEMPT, payload: payload });
export const getActivitiesSuccess = (payload) => ({ type: GET_ACTIVITIES_SUCCESS, payload: payload });
export const getActivitiesFailure = (payload) => ({ type: GET_ACTIVITIES_FAILURE, payload: payload });

export const getBannersAttempt = (payload) => ({ type: GET_BANNERS_ATTEMPT, payload: payload });
export const getBannersSuccess = (payload) => ({ type: GET_BANNERS_SUCCESS, payload: payload });
export const getBannersFailure = (payload) => ({ type: GET_BANNERS_FAILURE, payload: payload });

export const getResortAttempt = (payload) => ({ type: GET_RESORT_ATTEMPT, payload: payload });
export const getResortSuccess = (payload) => ({ type: GET_RESORT_SUCCESS, payload: payload });
export const getResortFailure = (payload) => ({ type: GET_RESORT_FAILURE, payload: payload });

export const getRoomAttempt = (payload) => ({ type: GET_ROOM_ATTEMPT, payload: payload });
export const getRoomSuccess = (payload) => ({ type: GET_ROOM_SUCCESS, payload: payload });
export const getRoomFailure = (payload) => ({ type: GET_ROOM_FAILURE, payload: payload });

export const getPageAttempt = (payload) => ({ type: GET_PAGE_ATTEMPT, payload: payload });
export const getPageSuccess = (payload, id_slug) => ({ type: GET_PAGE_SUCCESS, payload: payload, id_slug: id_slug });
export const getPageFailure = (payload) => ({ type: GET_PAGE_FAILURE, payload: payload });

export const toggleBookingPanel = () => ({ type: TOGGLE_BOOKING_PANEL });
export const setBookingResort = (payload) => ({ type: SET_BOOKING_RESORT, payload: payload });
export const setBookingDestination = (payload) => ({ type: SET_BOOKING_DESTINATION, payload: payload });
export const updateBooking = (payload) => ({ type: UPDATE_BOOKING, payload: payload });

export const toggleOverlay = (payload) => ({ type: TOGGLE_OVERLAY, payload: payload });
export const updateScroll = (payload) => ({ type: UPDATE_SCROLL, payload: payload });

let initial = {
  is_loading: {},
  booking_panel: {
    on: false,
    destination: null,
    resort: null,
    adults: 1,
    rooms: 1,
    children: 0,
    nights: null,
    checkin: null,
    checkout: null,
    discount: null
  },
  overlay: false,
  awards: null,
  banners: null,
  rooms: {},
  pages: {},
  subpages: {},
  session: null,
  activities: null,
  home_menu: null,
  home_slider: { slides: null, is_loaded: false },
  offers: null,
  home_experiences: { cards: null, title: null, is_loaded: false },
  resorts_homes: {},
  isAuthenticated: false,
  current_user: null,
  highlights: [],
  topics: {},
  topics_loading: [],
  scroll: { scrollDirection: null, is_bottom: false, is_top: true },
};

export const appReducer = (state, action) => {
    state = state==null ? initial : state
    switch (action.type) {
            // GET_TOPIC_POSTS_FAILURE {{{
      case GET_TOPIC_POSTS_FAILURE: {
        const { topic_id } = action.payload
        const topics_loading = state.topics_loading
        return { ...state, topics_loading: topics_loading.filter(i => i !== topic_id) }
      }
            //}}}
            // GET_TOPIC_POSTS_SUCCESS {{{
        case GET_TOPIC_POSTS_SUCCESS: {
            const {topic_id, posts} = action.payload
            const topics = state.topics
            console.log({topic_id, posts})
            // const topics_loading = state.topics_loading.filter(i => i !== topic_id)
            return { ...state, topics: { ...topics, [topic_id]: posts } }
        }
            //}}}
            // GET_TOPIC_POSTS_ATTEMPT {{{
            case GET_TOPIC_POSTS_ATTEMPT: {
              const {topic_id} = action.payload
              // const topics_loading = state.topics_loading.push(topic_id)
              return state
              //return { ...state, topics_loading }
            }
            //}}}
            // GET_HIGHLIGHTS_SUCCESS {{{
        case GET_HIGHLIGHTS_SUCCESS: {
            const { posts } = action.payload
            return { ...state, highlights: posts } 
        }
            //}}}
            // GET_MENU_ATTEMPT {{{
        case GET_MENU_ATTEMPT:
            return {...state, is_loading: { ...state.is_loading, home_menu: true}}
            //}}}
            // GET_MENU_SUCCESS {{{
        case GET_MENU_SUCCESS:
            return { ...state, home_menu: action.payload.data.site, is_loading: { ...state.is_loading, home_menu: false} }
            //}}}
            // GET_MENU_FAILURE {{{
        case GET_MENU_FAILURE:
            return { ...state, is_loading: { ...state.is_loading, home_menu: false} }
            //}}}
            // GET_HOME_SLIDER_ATTEMPT {{{
        case GET_HOME_SLIDER_ATTEMPT:
            return state
            //}}}
            // GET_HOME_SLIDER_SUCCESS {{{
        case GET_HOME_SLIDER_SUCCESS:
            return { ...state, home_slider: { slides: action.payload.data.site.slider.frames, is_loaded: true } }
            //}}}
            // GET_HOME_SLIDER_FAILURE {{{
        case GET_HOME_SLIDER_FAILURE:
            return { ...state, home_slider: { slides: [], is_loaded: false } }
            //}}}
            // GET_EXPERIENCES_ATTEMPT {{{
        case GET_EXPERIENCES_ATTEMPT:
            return state
            //}}}
            // GET_EXPERIENCES_SUCCESS {{{
        case GET_EXPERIENCES_SUCCESS:
            return { ...state, home_experiences: { cards: action.payload.data.site.experiences.children, title: action.payload.data.site.experiences.title, is_loaded: true } }
            //}}}
            // GET_EXPERIENCES_FAILURE {{{

        case GET_EXPERIENCES_FAILURE:
            return { ...state, home_experiences: { cards: null, is_loaded: false } }

            //}}}
            // GET_AWARDS_ATTEMPT {{{
        case GET_AWARDS_ATTEMPT:
            return state
            //}}}
            // GET_AWARDS_SUCCESS {{{
        case GET_AWARDS_SUCCESS:
            return { ...state, awards: { 
                awards: action.payload.data.site.awards.children, 
                title: action.payload.data.site.awards.title, 
                short: action.payload.data.site.awards.short, 
                body: action.payload.data.site.awards.body, 
                blurb: action.payload.data.site.awards.blurb, 
                is_loaded: true } }
            //}}}
            // GET_AWARDS_FAILURE {{{

        case GET_AWARDS_FAILURE:
            return { ...state, awards: { awards: null, is_loaded: false } }

            //}}}
            // GET_BANNERS_ATTEMPT {{{
        case GET_BANNERS_ATTEMPT:
            return { ...state, banners: { banners: null, is_loading: true } }
            //}}}
            // GET_BANNERS_SUCCESS {{{
        case GET_BANNERS_SUCCESS:

            return { 
                ...state, 
                banners: { 
                    banners: action.payload.data.user.highlights.children.edges.reduce(function(acc, node , i) {
                                acc[node.slug] = node;
                                return acc;
                                }, {}), 
                    title: action.payload.data.site.resorts.title, 
                    is_loading: false 
                    }, 
                cruises: { 
                    cruises: action.payload.data.site.cruises.children.reduce(function(acc, node , i) {
                        acc[node.url.split("/").slice(-1)[0]] = node;
                                return acc;
                                }, {}), 
                    title: action.payload.data.site.cruises.title, 
                    is_loading: false 
                    } 
            }
            //}}}
            // GET_BANNERS_FAILURE {{{

        case GET_BANNERS_FAILURE:
            return { ...state, resorts: { resorts: null, is_loading: false } }

            //}}}
            // GET_RESORT_ATTEMPT {{{
        case GET_RESORT_ATTEMPT:
            return { 
                ...state, 
                resorts_homes: { 
                    ...state.resorts_homes, 
                    is_loading:  true
                } 
            }
            //}}}
            // GET_RESORT_SUCCESS {{{
        case GET_RESORT_SUCCESS:

            return {    
                ...state, 
                resorts_homes: { 
                    ...state.resorts_homes, 
                    [action.payload.data.site.resort.slug]: action.payload.data.site.resort,
                    is_loading: false
                } 
            }
            //}}}
            // GET_RESORT_FAILURE {{{

        case GET_RESORT_FAILURE:
            return state

            //}}}
            // GET_ROOM_ATTEMPT {{{
        case GET_ROOM_ATTEMPT:
            return state
            //}}}
            // GET_ROOM_SUCCESS {{{
        case GET_ROOM_SUCCESS:
            return { 
                ...state, 
                rooms: { 
                    ...state.rooms, 
                    [action.payload.data.site.room.db_id]: action.payload.data.site.room
                } 
            }
            //}}}
            // GET_ROOM_FAILURE {{{

        case GET_ROOM_FAILURE:
            return state

            //}}}
            // GET_PAGE_ATTEMPT {{{
        case GET_PAGE_ATTEMPT:
            return state
            //}}}
            // GET_PAGE_SUCCESS {{{
        case GET_PAGE_SUCCESS:
            return { 
                ...state, 
                pages: { 
                    ...state.pages, 
                    [action.id_slug]: action.payload.data.site.page
                } 
            }
            //}}}
            // GET_PAGE_FAILURE {{{

        case GET_PAGE_FAILURE:
            return state

            //}}}
            // GET_OFFERS_ATTEMPT {{{
        case GET_OFFERS_ATTEMPT:
            return state
            //}}}
            // GET_OFFERS_SUCCESS {{{
        case GET_OFFERS_SUCCESS: {
          const { posts } = action.payload
          return { ...state, offers: posts }
        }
            //}}}
            // GET_OFFERS_FAILURE {{{

        case GET_OFFERS_FAILURE:
            return state

            //}}}
            // GET_CHILDREN_ATTEMPT {{{
        case GET_CHILDREN_ATTEMPT:
            return state
            //}}}
            // GET_CHILDREN_SUCCESS {{{
        case GET_CHILDREN_SUCCESS:
            return { 
                ...state, 
                subpages: { 
                    ...state.subpages, 
                    [action.payload.data.site.page.db_id]: action.payload.data.site.page
                } 
            }
            //}}}
            // GET_CHILDREN_FAILURE {{{

        case GET_CHILDREN_FAILURE:
            return state

            //}}}
            // GET_ACTIVITIES_ATTEMPT {{{
        case GET_ACTIVITIES_ATTEMPT:
            return state
            //}}}
            // GET_ACTIVITIES_SUCCESS {{{
        case GET_ACTIVITIES_SUCCESS:
            return { ...state, activities: action.payload.data.site.activities }
            //}}}
            // GET_ACTIVITIES_FAILURE {{{

        case GET_ACTIVITIES_FAILURE:
            return state

            //}}}
            // TOGGLE_BOOKING_PANEL {{{

        case TOGGLE_BOOKING_PANEL:
            return {...state, booking_panel: { ...state.booking_panel, on: !state.booking_panel.on }}
            //return {...state, booking_panel_show: !state.booking_panel_show }

            //}}}
            // SET_BOOKING_RESORT {{{

        case SET_BOOKING_RESORT:
            return {...state, booking_panel: { ...state.booking_panel, ...action.payload }}
            //return {...state, booking_panel_show: !state.booking_panel_show }

            //}}}
            // SET_BOOKING_DESTINATION {{{

        case SET_BOOKING_DESTINATION:
            return {...state, booking_panel: { ...state.booking_panel, ...action.payload }}

            //}}}
            // UPDATE_BOOKING {{{

        case UPDATE_BOOKING:
            return {...state, booking_panel: { ...state.booking_panel, ...action.payload }}

            //}}}
            // TOGGLE_OVERLAY {{{

        case TOGGLE_OVERLAY:
            return {...state, overlay: action.payload!==null ? action.payload : !state.overlay }

            //}}}
            // UPDATE_SCROLL {{{

        case UPDATE_SCROLL:
            return {...state, scroll: action.payload }

            //}}}
        default:
            return state;
  }
};

//{{{ getHighlights 
export const getHighlights = () => {
    return dispatch => {
      fetch(`https://hawaamagazine.com/posts.json?featured=1`)
      .then( res => res.json())
      .then( posts => dispatch(getHighlightsSuccess({ posts })) )
    }
}
//}}}
//{{{ getTopicPosts 
export const getTopicPosts = ({topic_id}) => {
    return dispatch => {
        dispatch(getTopicPostsAttempt({topic_id}));
        try {
          fetch(`https://hawaamagazine.com/topics/${topic_id}/posts.json`)
          .then( res => res.json())
          .then( posts => dispatch(getTopicPostsSuccess({ posts, topic_id })) )
        }catch(error){
          dispatch(getTopicPostsFailure({topic_id}))
        }
    }
}
//}}}
//{{{ doGetMenu 
export const doGetMenu = (vars) => {
    return dispatch => {
//{{{ GetPostsQuery
        const GetMenuQuery = `
            {
            site(name: "sunrise") {
                destinations: page(slug: "destinations") {
                title
                children {
                        id
                        db_id
                        title
                        slug
                        photo {
                        photo_uri(size: "large")
                        title
                        }
                        children {
                            id
                            db_id
                            title
                            slug
                            room_price
                            photo {
                                photo_uri(size: "large")
                                title
                            }
                        }
                    }
                }
            }
            }
        `;
        //}}}
        dispatch(getMenuAttempt());
        return getGraph({
            operationName: "GetMenu",
            payload: GetMenuQuery,
            variables: vars
        }).then(response => { 
            dispatch(getMenuSuccess(JSON.parse(response)));
        })
    }
}
//}}}
//{{{ getHomeSlider 
export const getHomeSlider = (vars) => {
    return dispatch => {
        const GetHomeSliderQuery = `
        {
            site(name: "sunrise") {
                slider: page(slug: "frontpage_slider") {
                    title
                    frames {
                        id
                        photo {
                            title
                            photo_uri(size: "gallery")
                        }
                    }
                }
            }
        }
        `;
        dispatch(getHomeSliderAttempt());
        return getGraph({
            operationName: "GetHomeSlider",
            payload: GetHomeSliderQuery,
            variables: vars
        }).then(response => { 
            dispatch(getHomeSliderSuccess(JSON.parse(response)));
        })
    }
}
//}}}
//{{{ getExperiences 
export const getExperiences = (vars) => {
    return dispatch => {
        const GetExperiencesQuery = `
        {
            site(name: "sunrise") {
                experiences: page(slug: "sunrise_experiences") {
                    title
                    id
                    db_id
                    children {
                        id
                        db_id
                        title
                        slug
                        url_title
                        short
                        frames {
                            photo {
                                title
                                photo_uri(size: "medium")
                            }
                        }
                    }
                }
            }
        }
        `;
        dispatch(getExperiencesAttempt());
        return getGraph({
            operationName: "GetExperiences",
            payload: GetExperiencesQuery,
            variables: vars
        }).then(response => { 
            dispatch(getExperiencesSuccess(JSON.parse(response)));
        })
    }
}
//}}}
//{{{ getAwards 
export const getAwards = (vars) => {
    return dispatch => {
        const GetAwardsQuery = `
        {
            site(name: "sunrise") {
                awards: page(slug: "awards") {
                    title
                    blurb
                    body
                    short
                    id
                    db_id
                    children {
                        id
                        db_id
                        title
                        blurb
                        short
                        slug
                        photo {
                            title
                            photo_uri(size: "medium")
                        }
                    }
                }
            }
        }
        `;
        dispatch(getAwardsAttempt());
        return getGraph({
            operationName: "GetAwards",
            payload: GetAwardsQuery,
            variables: vars
        }).then(response => { 
            dispatch(getAwardsSuccess(JSON.parse(response)));
        })
    }
}
//}}}
//{{{ getOffers 
export const getOffers = (vars) => {
    return dispatch => {
      fetch(`https://hawaamagazine.com/topics/194467/posts.json`)
      .then( res => res.json())
      .then( posts => dispatch(getOffersSuccess({ posts })) )
    }
}
//}}}
//{{{ getResorts 
export const getResorts = (vars) => {
    return dispatch => {
        const GetResortsQuery = `
        {
            site(name: "sunrise") {
                resorts: page(slug: "all_resorts_slider") {
                    title
                    blurb
                    body
                    short
                    id
                    db_id
                    children {
                        id
                        db_id
                        title
                        slug
                        room_price
                        blurb
                        url
                        short
                        photo {
                            title
                            photo_uri(size: "medium")
                        }
                    }
                }
                cruises: page(slug: "all_cruises_slider") {
                    title
                    blurb
                    body
                    short
                    id
                    db_id
                    children {
                        id
                        db_id
                        title
                        slug
                        room_price
                        blurb
                        url
                        short
                        photo {
                            title
                            photo_uri(size: "medium")
                        }
                    }
                }
            }
        }
        `;
        dispatch(getBannersAttempt());
        return getGraph({
            operationName: "GetResorts",
            payload: GetResortsQuery,
            variables: vars
        }).then(response => { 
            dispatch(getBannersSuccess(JSON.parse(response)));
        })
    }
}
//}}}
//{{{ getResort 
export const getResort = ({slug }) => {
    return dispatch => {
        const GetResortQuery = `
        {
            site(name: "sunrise") {
                resort: page(slug: "${ slug }") {
                    title
                    slug
                    blurb
                    body
                    short
                    id
                    db_id
                    overview: page(slug: "overview"){
                        id
                        db_id
                        blurb
                        body
                        title
                        resort_address
                        resort_facebook
                        resort_twitter
                        resort_instagram
                        resort_tumblr
                        resort_youtube
                        resort_pinterest
                        frames {
                            id
                            photo {
                                id
                                photo_uri(size: "medium")
                            }
                        }
                        tags {
                            name
                        }
                    }
                    accommodation: page(slug: "accommodation") {
                        id
                        db_id
                        title
                        blurb
                        children {
                            id
                            db_id
                            title
                            children {
                                id
                                db_id
                                title
                                slug
                                url_title
                                room_size
                                room_price
                                room_max_occupancy
                                room_occupancy_adults_children
                                blurb
                                url
                                short
                                photo {
                                    title
                                    photo_uri(size: "medium")
                                }
                            }
                        }
                    }
                    dining: page(slug: "dining") {
                        id
                        db_id
                        title
                        blurb
                        children {
                            id
                            db_id
                            title
                            children {
                                id
                                db_id
                                title
                                url_title
                                slug
                                url
                                short
                                photo {
                                    photo_uri(size: "medium")
                                }
                                downloads {
                                  uri
                                }
                            }
                        }
                    }
                    spawellness: page(slug: "spa_and_wellness") {
                        id
                        db_id
                        title
                        blurb
                        children {
                            id
                            db_id
                            title
                            body
                            children {
                                id
                                db_id
                                title
                                url_title
                                slug
                                url
                                short
                                photo {
                                    photo_uri(size: "medium")
                                }
                            }
                        }
                    }
                }
            }
        }
        `;
        dispatch(getResortAttempt());
        return getGraph({
            operationName: "GetResort",
            payload: GetResortQuery,
            variables: {}
        }).then(response => { 
            dispatch(getResortSuccess(JSON.parse(response)));
        })
    }
}
//}}}
//{{{ getRoom 
export const getRoom = ({room}) => {
    return dispatch => {
        const GetRoomQuery = `
        {
            site(name: "sunrise") {
                room: page(id: "${ room }") {
                    title
                    slug
                    blurb
                    room_size
                    room_view                 
                    room_vtour             
                    room_video            
                    room_booking_url  
                    room_price
                    room_max_occupancy
                    room_occupancy_adults_children
                    body
                    short
                    id
                    db_id
                    photo {
                        photo_uri(size: "medium")
                        title
                    }
                    frames {
                        id
                        photo {
                            photo_uri(size: "large")
                            title
                        }
                    }
                }
            }
        }
        `;
        dispatch(getRoomAttempt());
        return getGraph({
            operationName: "GetRoom",
            payload: GetRoomQuery,
            variables: {}
        }).then(response => { 
            dispatch(getRoomSuccess(JSON.parse(response)));
        })
    }
}
//}}}
//{{{ getPage 
export const getPage = ({page_id, options}) => {
    return dispatch => {
        const pageql = options.fragment ? options.fragment : ` 
                    title
                    slug
                    url_title
                    blurb
                    body
                    short
                    id
                    db_id
                    parent_id
                    photo {
                        photo_uri(size: "medium")
                        title
                    }
                    frames {
                        id
                        photo {
                            photo_uri(size: "medium")
                            title
                        }
                    }
                `
        const id_slug = options && options.slug ?  `slug: "${options.slug}"` : `id: "${ page_id }"`
        const idslug = options && options.slug ?  options.slug : page_id
        const GetPageQuery = `
        {
            site(name: "sunrise") {
                page(${ id_slug }) {
                ${ pageql }
                }
            }
        }
        `;
        dispatch(getPageAttempt());
        return getGraph({
            operationName: "GetPage",
            payload: GetPageQuery,
            variables: {}
        }).then(response => { 
          //dispatch(getPageSuccess(JSON.parse(response), idslug));
        })
    }
}
//}}}
//{{{ getActivities 
export const getActivities = (vars) => {
    return dispatch => {
        const GetActivitiesQuery = `
        {
            site(name: "sunrise") {
                activities: page(slug: "activities") {
                    title
                    blurb
                    body
                    short
                    id
                    db_id
                    children {
                        id
                        db_id
                        title
                        slug
                        url_title
                        blurb
                        short
                        photo {
                            title
                            photo_uri(size: "medium")
                        }
                    }
                }
            }
        }
        `;
        dispatch(getActivitiesAttempt());
        return getGraph({
            operationName: "GetActivities",
            payload: GetActivitiesQuery,
            variables: vars
        }).then(response => { 
            dispatch(getActivitiesSuccess(JSON.parse(response)));
        })
    }
}
//}}}
//{{{ getChildren 
export const getChildren = ({ page_id }) => {
    return dispatch => {
        const GetChildrenQuery = `
        {
            site(name: "sunrise") {
                page(id: "${ page_id }") {
                    title
                    blurb
                    body
                    short
                    id
                    db_id
                    children {
                        id
                        db_id
                        title
                        blurb
                        short
                        photo {
                            title
                            photo_uri(size: "medium")
                        }
                    }
                }
            }
        }
        `;
        dispatch(getActivitiesAttempt());
        return getGraph({
            operationName: "GetChildren",
            payload: GetChildrenQuery,
            variables: null
        }).then(response => { 
            dispatch(getChildrenSuccess(JSON.parse(response)));
        })
    }
}
//}}}



// WEBPACK FOOTER //
// ./src/store/reducers/index.js